import Axios from 'axios';

const UNAUTHORIZED = 401;

const axios = Axios.create({
  baseURL: process.env.REACT_APP_BASE_URL
});

axios.interceptors.request.use((config) => {
  let token = '';
  if (typeof window !== 'undefined') {
    token = localStorage.getItem('token');
  }

  config.headers['Authorization'] = `Bearer ${token}`;
  return config;
});

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const response = error?.response;
    if (response?.status === UNAUTHORIZED) {
      if (typeof window !== 'undefined') {
        window.localStorage.clear();
        window.location.replace('/login');
      }
    }
    return Promise.reject(error);
  }
);

export { axios };
